module.exports = __webpack_public_path__ + "img/img_1.22c9cf7f.jpg";